module.exports = __webpack_public_path__ + "img/login-v2-dark.c114296c.png";